"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var event_bus_1 = require("@cian/event-bus");
var favorite_button_1 = require("../../shared/favorite_button");
var state_1 = require("../../shared/favorite_button/state");
function initializeFavoriteButton(containers, isActive, newbuildingId, pageType, apiBaseUrl, customPageUrl, userIsAuthenticated, showLoginPopup) {
    var initialState = {
        isActive: isActive,
        motivationIsVisible: false,
    };
    var store = redux_1.createStore(state_1.favoriteButtonReducer, initialState);
    // при автодобавлении ЖК в избранное после добавления объявки через МВК или из списка квартир от застройщика
    // перехватываем событие добавления и меняем состояние кнопки избранного для ЖК
    var eventBus = event_bus_1.getEventBusIfDefined();
    if (eventBus) {
        eventBus.subscribe('newbuilding_added_to_favorite', function (event) {
            if (Number(event.type) === newbuildingId) {
                store.dispatch(state_1.toggleFavoriteAction());
            }
        });
    }
    containers.forEach(function (container) {
        react_dom_1.render(React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(favorite_button_1.FavoriteButtonContainer, { newbuildingId: newbuildingId, apiBaseUrl: apiBaseUrl, pageType: pageType, withoutText: container.withoutText, customPageUrl: customPageUrl, userIsAuthenticated: userIsAuthenticated, showLoginPopup: showLoginPopup, withoutMotivation: container.withoutMotivation })), container.root);
    });
}
exports.initializeFavoriteButton = initializeFavoriteButton;



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/favorite_button.tsx
// module id = 296
// module chunks = 2